import type { z } from 'zod';

import type { LegacyExamTypeSchema } from './schemas';

type LegacyExamTypeField = keyof z.infer<typeof LegacyExamTypeSchema>;

const listAttributes = [
  'id',
  'subject',
  'type',
  'creationDatetime',
  'editDatetime',
  'label',
  'unitPayDuration',
  'unitPayRate',
] as const satisfies readonly LegacyExamTypeField[];

const getAttributes = [...listAttributes] as const satisfies readonly LegacyExamTypeField[];

export const LegacyExamTypeAttributes = {
  List: listAttributes,
  Get: getAttributes,
};
